import { createSlice } from "@reduxjs/toolkit";
import DASHBOARD_API from "api/dashboard";
import AUTH_API from "api/auth";
import HELPERS from "utils/helper";
import { STEP_KEY } from "utils/steps";
import Helper from "bizcharts/lib/g-components/Base/Helper";
import moment from "moment";



export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    tasks: [],
    stepReflections: {},
    fetched: false,
    profile: null,
    quickReflection: {
      show: false,
    },
    showThankYou: false,
    show_feedback: false,
    isDropdownOpen: false,
    professionalSummary: {Api_response: {}, edited: false},
    upcomingMeetings: [],
    upcomingMeetingsFilters: {
      "IN": "Interview",
      "CM": "Coach Meeting",
      "PM": "Peer Meeting",
      "NE": "Networking",
      "FRI": "First Round Interview",
      "SRI": "Second Round Interview",
      "TRI": "Third Round Interview",
      "GC": "Group Coworking",
      "GA": "Group Coaching",
      "TS": "Therapy Session",
      "ABM": "Accountability Buddy",
      "OTH": "Other",
    },
    shortTermGoals: [],
    shortTermGoalsConflict: false, 
    timeline: [],
    timelineStep: [],
    coachDetails:[],
  },
  reducers: {
    toggleDropdown: (state, action) => {
      console.log('sss toggleDropdown', action, window.location.pathname.endsWith("/dashboard") ? !state.isDropdownOpen : false)
      state.isDropdownOpen = !action ? false : window.location.pathname.endsWith("/dashboard") ? !state.isDropdownOpen : false;
    },
    updateTimelineStep: (state, action) => {
      // state.timelineStep = action.payload;
      const sortedData = action.payload.sort((a, b) => {
        const dateA = moment(a.year, "YYYY");
        const dateB = moment(b.year, "YYYY");
        
        return dateA - dateB;
      });
      state.timelineStep = sortedData;
    },
    updateTasks: (state, action) => {
      HELPERS.log("sorted tasks", HELPERS.orderTasks(action.payload));
      state.tasks = HELPERS.orderTasks(action.payload);
    },
    updateCoachNotes: (state, action) => {
      state.coachDetails = action.payload;
    },
    updateTimeline: (state, action) => {
      state.timeline = action.payload;
    },
    updateShortTermGoals: (state, action) => {
      state.shortTermGoals = action.payload;
    },
    updateProfessionalSummary: (state, action) => {
      console.log('sss updateProfessionalSummary', state, action)
      state.professionalSummary = action.payload;
    },
    updateUpcomingMettings: (state, action) => {
      // state.upcomingMeetings = action.payload;
      const sortedData = action.payload.sort((a, b) => {
        const dateA = moment(`${a.date} ${a.time}`, "YYYY-MM-DD hh:mm A");
        const dateB = moment(`${b.date} ${b.time}`, "YYYY-MM-DD hh:mm A");
        
        return dateA - dateB;
      });
      state.upcomingMeetings = sortedData;
    },
    updateUpcomingMettingsFilters: (state, action) => {
      state.upcomingMeetingsFilters = action.payload;
    },
    setShortTermGoalsConflict: (state, action) => {
      state.shortTermGoalsConflict = action.payload
    },
    updateStepReflections: (state, action) => {
      let stepReflections = {};

      for (var reflection of action.payload) {
        if(!stepReflections[reflection.step]){
          stepReflections[reflection.step] = reflection;
        }
      }

      state.stepReflections = stepReflections;
    },
    updateFetched: (state, action) => {
      state.fetched = action.payload;
    },
    updateStepReflection: (state, action) => {
      HELPERS.log(`Received some payload for updateStepReflection`, action);
      let stepReflections = state.stepReflections;

      HELPERS.log(`Updating`, stepReflections[action.payload.stepKey]);
      stepReflections[action.payload.stepKey] = {
        ...stepReflections[action.payload.stepKey],
        ...action.payload.data,
      };
      state.stepReflections = stepReflections;
    },
    updateTask: (state, action) => {
      HELPERS.log(`Received some payload for updateTask`, action);
      let tasks = state.tasks;
      let add = true;

      for (var index = 0; index < tasks.length; ++index) {
        if (tasks[index].id === action.payload.id) {
          tasks[index] = action.payload;

          if (action.payload.step_reflection) {
            let stepReflections = state.stepReflections;
            for (let stepReflection in stepReflections) {
              if (
                stepReflections[stepReflection].id ===
                action.payload.step_reflection
              ) {
                stepReflections[stepReflection].complete_by =
                  action.payload.due_date;
                break;
              }
            }
          }

          add = false;
          break;
        }
      }

      if (add) {
        tasks.push(action.payload);
      }

      HELPERS.log("sorted tasks", HELPERS.orderTasks(tasks));
      state.tasks = HELPERS.orderTasks(tasks);

      HELPERS.log("updateTask", state.tasks);
    },
    deleteTask: (state, action) => {
      HELPERS.log(`Received some payload for updateTask`, action);
      let tasks = state.tasks;

      for (var index = 0; index < tasks.length; ++index) {
        if (tasks[index].id === action.payload) {
          tasks.splice(index, 1);
          break;
        }
      }

      state.tasks = HELPERS.orderTasks(tasks);

      HELPERS.log("updateTask", state.tasks);
    },
    updateProfile: (state, action) => {
      state.profile = { ...state.profile, ...action.payload };
    },
    updateQuickReflection: (state, action) => {
      HELPERS.log(`updateQuickReflection called with payload`, action);
      state.quickReflection = action.payload;
    },
    setShowThankYou: (state, action) => {
      state.showThankYou = action.payload;
    },
    setShowFeedback: (state, action) => {
      state.show_feedback = action.payload;
    },
    addTask: (state, action) => {
      HELPERS.log(`Received some payload for addTask`, action);
      let tasks = state.tasks;
      tasks.push(action.payload);
      HELPERS.log("sorted tasks", HELPERS.orderTasks(tasks));
      state.tasks = HELPERS.orderTasks(tasks);
    },
  },
});

export const {
  updateTasks,
  updateTimelineStep,
  updateTimeline,
  updateCoachNotes,
  updateShortTermGoals,
  updateProfessionalSummary,
  updateUpcomingMettings,
  updateStepReflections,
  updateFetched,
  updateStepReflection,
  updateProfile,
  updateTask,
  deleteTask,
  updateQuickReflection,
  setShowThankYou,
  setShortTermGoalsConflict,
  setShowFeedback,
  addTask,
  toggleDropdown,
  updateUpcomingMettingsFilters,
} = dashboardSlice.actions;

export const fetchDataAsync = () => (dispatch) => {
  DASHBOARD_API.get().then((resp) => {
    if (resp && resp.data) {
      console.log("$$woken$$", "dashboard data", resp.data);
      HELPERS.log("updateFetched");
      dispatch(updateFetched(true));
      HELPERS.log("updateTasks");
      dispatch(updateTasks(resp.data.tasks));
      HELPERS.log("updateStepReflections");
      dispatch(setShowFeedback(resp.data.show_feedback))
      dispatch(updateStepReflections(resp.data.stepReflections));
      dispatch(
        updateProfile({
          first_name: resp.data.first_name,
          last_name: resp.data.last_name,
          hours_per_week_commitment: resp.data.hours_per_week_commitment,
          daily_commitment: resp.data.daily_commitment,
          country: resp.data.country,
          country_code: resp.data.country_code,
          dob: resp.data.dob,
          email: resp.data.email,
          phone: resp.data.phone,
          city: resp.data.city,
          state: resp.data.state,
          configurations: resp.data.configurations,
          date_joined: resp.data.date_joined,
          impersonated: resp.data.impersonated,
        })
      );
    }
  });
};

export const fetchCoachSummaryAsync = (user_id) => (dispatch) =>{
  // dispatch(updateCoachNotes({
  //   // id: 74,
  //   // first_name: "Rachel",
  //   // last_name: "Serwetz",
  //   last_updated: "2025-05-02",
  //   note: "Rachel is focused on exploring her best career direction before starting her job search. She stays accountable and self-aware to overcome any mindset limitations."
  // }))
  DASHBOARD_API.getCoachSummary(user_id).then((resp) => {
    if (resp && resp.data && resp.data.coachDetails) {
      // console.log('sss fetchCoachSummaryAsync', user_id, resp)
      dispatch(updateCoachNotes(resp.data.coachDetails))
    }
    else{
      dispatch(updateCoachNotes([]))
    }
  });
}

export const setCoachSummaryAsync = (data, user_id) => (dispatch) =>{
  HELPERS.log(`Received response for setCoachSummaryAsync`, data);
  // dispatch(updateCoachNotes({
  //   // id: 74,
  //   // first_name: "Rachel",
  //   // last_name: "Serwetz",
  //   last_updated: "2025-05-02",
  //   note: data.coachSummary
  // }))
  console.log('sss data', data)
  return DASHBOARD_API.updateCoachSummary(data.coachSummary, user_id).then((resp) => {
    HELPERS.log(`Received response for setCoachSummaryAsync`, resp);
    if (resp && resp.data && resp.data.coachDetails) {
      dispatch(updateCoachNotes(resp.data.coachDetails))
    }
    else{
      dispatch(updateCoachNotes([]))
    }
  });
}

export const fetchProfessionalSummaryAsync = (user_id) => (dispatch) => {

  return AUTH_API.getMaterials()
    .then((response) => {
      const form_values = response.data.length > 0 ? response.data[0].professional_summary : {};
      console.log("sss fetchProfessionalSummaryAsync", response, form_values);
      // Ensure Api_response is an object
      const updatedApiResponse = {
        ...form_values,
        edited: form_values.generate || form_values.edited ? true : false,
        id: response.data[0].id
      };

      dispatch(updateProfessionalSummary({
        Api_response: updatedApiResponse,
        edited: form_values.generate || form_values.edited ? true : false,
      }))
    })
    .catch((err) => console.log("prof summary get Api error!", err));
}

export const fetchTimelineStepAsync = (user_id) => (dispatch) => {
  console.log('sss fetchTimelineStepAsync', user_id)
  DASHBOARD_API.getTimelineStep(user_id).then((resp) => {
    if (resp && resp.data && resp.data.timelineStep) {
      dispatch(updateTimelineStep(resp.data.timelineStep))
    }
    else{
      dispatch(updateTimelineStep([]))
    }
  });
}

export const fetchTimelineAsync = (user_id) => (dispatch) => {
  DASHBOARD_API.getTimeline(user_id).then((resp) => {
    if (resp && resp.data && resp.data.career_roadmap) {
      dispatch(updateTimeline(resp.data.career_roadmap))
    }
    else{
      dispatch(updateTimeline([]))
    }
  });
}

export const fetchShortTermGoalsAsync = (user_id) => (dispatch) => {
  DASHBOARD_API.getShortTermGoals(user_id).then((resp) => {
    console.log(resp, "short goal test")
    if (resp && resp.data.short_term_goal) {
      dispatch(updateShortTermGoals(resp.data.short_term_goal))
    }
    else{
      dispatch(updateShortTermGoals([]))
    }
  });
}

export const fetchUpcomingMeetingsAsync = (user_id) => (dispatch) => {
  DASHBOARD_API.getUpcomingMeetings(user_id, false).then((resp) => {
    console.log(resp, "checking res upcoming")
    // dispatch(updateUpcomingMettingsFilters({}))
    if (resp && resp.data.upcoming_meetings) {
      dispatch(updateUpcomingMettings(resp.data.upcoming_meetings))
      // dispatch(updateUpcomingMettingsFilters(resp.data.types))
    }
  });
}

export const fetchTasksAsync = () => (dispatch) => {
  DASHBOARD_API.fetchTasksAsync().then((resp) => {
    if (resp && resp.data) {
      HELPERS.log("updateTasks");
      dispatch(updateTasks(resp.data));
    }
  });
};

export const setShortTermGoalsAsync = (data, user_id) => (dispatch) => {
  console.log('Received response for setShortTermGoalsAsync', data, user_id)
  // dispatch(updateShortTermGoals(data));
  return DASHBOARD_API.setShortTermGoals(data, user_id).then((resp) => {
    HELPERS.log(`Received response for setShortTermGoalsAsync`, resp);
    if (resp && resp.data) {
      dispatch(updateShortTermGoals(resp.data));
    }
  });
}


export const deleteShortTermGoalsAsync = (data, stepId, user_id) => (dispatch) => {

  console.log('Received response for deleteShortTermGoalsAsync', data, stepId, user_id)
  // dispatch(updateShortTermGoals(data));
  return DASHBOARD_API.deleteShortTermGoals(data, stepId, user_id).then((resp) => {

    HELPERS.log(`Received response for deleteShortTermGoalsAsync`, resp);

    if (resp && resp.data) {

      dispatch(updateShortTermGoals(resp.data));

    }

  });

}

export const setProfessionalSummaryAsync = (data, id, step) => (dispatch) => {
  return AUTH_API.patchMaterials(data, id, step)
    .then((response) => {
      console.log("patch Api data", response);
      if (response && response.data.professional_summary) {
        const updatedApiResponse = {
        ...response.data.professional_summary,
        id: response.data.id
      };
        dispatch(updateProfessionalSummary({"Api_response": updatedApiResponse, edited: response.data.professional_summary.edited}));
      }
    })
    .catch((err) => console.log("prof summary patch Api error!", err));
}

export const setTimelineStepAsync = (data, user_id) => (dispatch) => {
  console.log('Received response for setTimelineStepAsync', data, user_id)
  // dispatch(updateTimelineStep(data));
  return DASHBOARD_API.updateTimelineStep(data, user_id).then((resp) => {
    HELPERS.log(`Received response for setTimelineStepAsync`, resp);
    if (resp && resp.data) {
      dispatch(updateTimelineStep(resp.data));
    }
  });
}

export const setTimelineAsync = (data, user_id) => (dispatch) => {
  // dispatch(updateTimeline(data));
  console.log('sss handleSaveGoals setTimelineAsync', data, user_id)
  return DASHBOARD_API.updateTimeline(data, user_id).then((resp) => {
    HELPERS.log(`Received response for setTimelineAsync`, resp);
    if (resp && resp.data) {
      dispatch(updateTimeline(resp.data));
    }
  });
}

export const setShortTermGoalsAndTimelineAsync = (timeline, shortTermGoal, user_id) => async (dispatch) => {
  // console.log('Received response for setShortTermGoalsAndTimelineAsync', timeline, shortTermGoal, user_id)
  try {
    const [shortTermGoalResp, timelineResp] = await Promise.all([
      DASHBOARD_API.setShortTermGoals(shortTermGoal, user_id),
      DASHBOARD_API.updateTimeline(timeline, user_id),
    ]);
    
    HELPERS.log(`Received response for setShortTermGoalsAsync`, shortTermGoalResp);
    if (shortTermGoalResp && shortTermGoalResp.data && timelineResp && timelineResp.data) {
      dispatch(updateShortTermGoals(shortTermGoalResp.data));
      dispatch(updateTimeline(timelineResp.data));
    }

  } catch (error) {
    console.error('Error in API calls:', error);
    // Handle error appropriately
  }
}

export const setUpcomingMeetingsAsync = (data, user_id) => (dispatch) => {
  //dispatch(updateUpcomingMettings(data));
  console.log('sss data', data)
  return DASHBOARD_API.updateUpcomingMeetings(data, user_id).then((resp) => {
    HELPERS.log(`Received response for setUpcomingMeetingsAsync`, resp);
    if (resp && resp.data.upcoming_meetings) {
      dispatch(updateUpcomingMettings(resp.data.upcoming_meetings));
    }
  });
}

export const setUpcomingMeetingsFiltersAsync = (data, user_id) => (dispatch) => {
  dispatch(updateUpcomingMettingsFilters(data));
  console.log('sss data updateUpcomingMettingsFilters', data)
  // return DASHBOARD_API.updateUpcomingMeetingsFilter(data, user_id).then((resp) => {
  //   HELPERS.log(`Received response for setUpcomingMeetingsFiltersAsync`, resp);
  //   if (resp && resp.data.upcoming_meetings) {
  //     dispatch(updateUpcomingMettingsFilters(resp.data.upcoming_meetings));
  //   }
  // });
}

export const setStepGoalAsync = (stepId, stepKey, target, taskTitle) => (
  dispatch
) => {
  return DASHBOARD_API.setGoal(stepId, target, taskTitle).then((resp) => {
    HELPERS.log(`Received response for setStepGoalAsync`, resp);
    if (resp && resp.data && resp.data.complete_by) {
      dispatch(
        updateStepReflection({
          stepId,
          stepKey,
          data: { complete_by: resp.data.complete_by },
        })
      );
      dispatch(updateTask(resp.data.task));
    }
  });
};

export const setStepNotifiedAsync = (stepId, stepKey) => (dispatch) => {
  return DASHBOARD_API.setStepNotified(stepId).then((resp) => {
    HELPERS.log(`Received response for setStepNotifiedAsync`, resp);
    if (resp && resp.data && resp.data.notified) {
      dispatch(
        updateStepReflection({
          stepId,
          stepKey,
          data: { notified: resp.data.notified, status: resp.data.status },
        })
      );
    }
  });
};

export const updateStepReflectionAsync = (stepId, data) => (dispatch) => {
  return DASHBOARD_API.updateStepReflection(stepId, data).then((resp) => {
    HELPERS.log(`Received response for updateStepReflectionAsync`, resp);
    dispatch(
      updateStepReflection({
        data: resp.data,
      })
    );
  });
};

export const updateStepReflectionKPIAsync = (stepId, data) => (dispatch) => {
  return DASHBOARD_API.updateStepReflection(stepId, data).then((resp) => {
    HELPERS.log(`Received response for updateStepReflectionKPIAsync`, resp);
    dispatch(
      updateStepReflection({
        data: resp.data,
      })
    );
    dispatch(updateQuickReflection({ show: false, stepId: null }));
    dispatch(setShowThankYou(true));
  });
};

const updateYourCommitmentAsync = (data) => (dispatch) => {
  return AUTH_API.updateYourCommitment(data).then((resp) => {
    HELPERS.log(`Received response for updateYourCommitmentAsync`, resp);
    if (resp && resp.data) {
      dispatch(updateProfile(data));
    }
  });
};

export const updateHoursPerWeekCommitmentAsync = (hours) =>
  updateYourCommitmentAsync({
    hours_per_week_commitment: hours,
  });

export const updateProfileAsync = (data, Stepname) => (dispatch) => {
  HELPERS.log("Executing updateProfileAsync...", data, Stepname);
  DASHBOARD_API.updateProfile(data, Stepname).then((resp) => {
    HELPERS.log("Received response for updateProfileAsync", resp, Stepname);
    dispatch(updateProfile(resp.data));
  });
};

export const addTaskAsync = (data) => (dispatch) => {
  HELPERS.log("Executing addTaskAsync...", data);
  DASHBOARD_API.addTask(data).then((resp) => {
    HELPERS.log("Received response for addTaskAsync", resp.data);
    dispatch(addTask(resp.data));
  });
};

export const updateTaskAsync = (id, data) => (dispatch) => {
  HELPERS.log("Executing updateTaskAsync...");
  DASHBOARD_API.updateTask(id, data).then((resp) => {
    HELPERS.log("Received response for updateTaskAsync", resp.data);
    dispatch(updateTask(resp.data));
  });
};

export const deleteTaskAsync = (id) => (dispatch) => {
  HELPERS.log("Executing deleteTaskAsync...");
  DASHBOARD_API.deleteTask(id)
    .then((resp) => {
      HELPERS.log("Received response for deleteTaskAsync", resp.data);
      dispatch(deleteTask(id));
    })
    .catch((err) => {
      HELPERS.log("error in API");
    });
};

export const selectCoachNotesDetails = (state) => state.dashboard.coachDetails
export const selectTimeline = (state) => state.dashboard.timeline;
export const selectTimelineStep = (state) => state.dashboard.timelineStep;
export const selectProfessionalSummary = (state) => state.dashboard.professionalSummary;
export const selectUpcomingMeetings = (state) => state.dashboard.upcomingMeetings;
export const selectUpcomingMeetingsFilters = (state) => state.dashboard.upcomingMeetingsFilters;
export const selectShortTermGoals = (state) => state.dashboard.shortTermGoals;
export const selectShortTermGoalsConflict = (state) => state.dashboard.shortTermGoalsConflict
export const selectTasks = (state) => state.dashboard.tasks;
export const selectFetched = (state) => state.dashboard.fetched;
export const selectProfile = (state) => state.dashboard.profile;
export const selectQuickReflectionInfo = (state) =>
  state.dashboard.quickReflection;
export const selectShowThankYou = (state) => state.dashboard.showThankYou;
export const selectConfigurations = (state) =>
  state.dashboard.profile ? state.dashboard.profile.configurations : {};
export const selectStepReflections = (state) => state.dashboard.stepReflections;
export const selectStepReflection = (state) => (stepKey) =>
  state.dashboard.stepReflections[stepKey];
export const selectAssessmentStepInfo = (state) =>
  state.dashboard.stepReflections[STEP_KEY.Assessment];
export const selectTargetRolesStepInfo = (state) =>
  state.dashboard.stepReflections[STEP_KEY.TargetRoles];
export const selectTargetIndustriesStepInfo = (state) =>
  state.dashboard.stepReflections[STEP_KEY.TargetIndustries];
export const selectTargetRolesIndustriesStepInfo = (state) =>
  state.dashboard.stepReflections[STEP_KEY.TargetRolesAndIndustries];
export const selectResearchRolesStepInfo = (state) =>
  state.dashboard.stepReflections[STEP_KEY.ResearchRoles];
export const selectResearchIndustriesStepInfo = (state) =>
  state.dashboard.stepReflections[STEP_KEY.ResearchIndustries];
export const selectNetworkingStepInfo = (state) => [
  state.dashboard.stepReflections[STEP_KEY.Contacts],
  state.dashboard.stepReflections[STEP_KEY.EmailDrafts],
  state.dashboard.stepReflections[STEP_KEY.Tracker],
  state.dashboard.stepReflections[STEP_KEY.CallPrep],
  state.dashboard.stepReflections[STEP_KEY.CallNotes],
];
export const selectNetworkingReflectionsStepInfo = (state) =>
  state.dashboard.stepReflections[STEP_KEY.NetworkingReflections];
export const selectLearningOpportunityStepInfo = (state) =>
  state.dashboard.stepReflections[STEP_KEY.LearningOpportunities];
export const selectMaterialsStepInfo = (state) => [
  state.dashboard.stepReflections[STEP_KEY.ProfessionalSummary],
  state.dashboard.stepReflections[STEP_KEY.Resume],
  state.dashboard.stepReflections[STEP_KEY.Linkedin],
  state.dashboard.stepReflections[STEP_KEY.CoverLetter],
];
export const selectJobSearchStepInfo = (state) => [
  state.dashboard.stepReflections[STEP_KEY.ApplicationTracker],
  state.dashboard.stepReflections[STEP_KEY.InterviewResearch],
  state.dashboard.stepReflections[STEP_KEY.InterviewPractice],
];
export const selectJobReflectionsStepInfo = (state) =>
  state.dashboard.stepReflections[STEP_KEY.Reflections];

export default dashboardSlice.reducer;
